import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./index.module.css";

export default function ReportItemSessionOverview({ item, isOdd }) {
  return (
    <div className={classNames(styles.row, isOdd && styles.odd)}>
      <div className={styles.sessionTitle}>{item["Session Title"]}</div>
      <div className={styles.attending}>{item.Attending}</div>
      <div className={styles.capacity}>{item["Room Capacity"]}</div>
      <div className={styles.pct}>{item.PCT}</div>
    </div>
  );
}

ReportItemSessionOverview.propTypes = {
  item: PropTypes.shape({
    "Session Title": PropTypes.string,
    Attending: PropTypes.number,
    "Room Capacity": PropTypes.number,
    PCT: PropTypes.string,
  }),
  isOdd: PropTypes.bool,
};
